import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination, Tooltip } from 'antd'
import MyIcon from '../../components/general/icon'
import FilterPresentationVenue from './filter'
import PresentationVenueRibbon from './ribbon'
import DeletePresentationVenue from './delete'
import AddPresentationVenue from './add'
import EditPresentationVenue from './edit'
import EmptyPresentationVenue from './empty'

export default function PresentationVenue() {
    const [currentPage, setCurrentPage] = useState(1)
    const [propsData, setPropsData] = useState({})
    const [venueData, setVenueData] = useState({})
    const [isDeleteVisible, setIsDeleteVisible] = useState(false)
    const [isAddVisible, setIsAddVisible] = useState(false)
    const [isEditVisible, setIsEditVisible] = useState(false)
    const [isEmptyVisible, setIsEmptyVisible] = useState(false)

    const initialConditions = {
        keywords: '',
        campus: 0,
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

    const getVenueData = () => {
        axios.post('/admin/venue/list', {
            keywords: filterValue.keywords,
            campus: filterValue.campus,
            slot_type: 1,
            page: currentPage,
            per_page: 20
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    setVenueData({
                        'total_page': response.data.total_page,
                        'current_page': response.data.current_page,
                        'total': response.data.total,
                        'list': response.data.list
                    })
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    useEffect(() => {
        getVenueData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, filterValue])

    const deleteVenue = (id, name) => {
        setIsDeleteVisible(true)
        setPropsData({ id, name })
    }

    const editVenue = (id, name, campus, slot_type) => {
        setIsEditVisible(true)
        setPropsData({ id, name, campus, slot_type })
    }

    const CAMPUS_MAP = {
        1: '兰州职业技术学院',
        2: '雁儿湾校区',
        3: '桃林校区'
    }

    return (
        <div className="public-page">
            <div className="public-container">
                <div className="public-header">
                    <div className="public-title">宣讲会场地管理</div>
                    <PresentationVenueRibbon filterValue={filterValue} setFilterValue={setFilterValue} isAddVisible={() => { setIsAddVisible(true) }} isEmptyVisible={() => { setIsEmptyVisible(true) }}/>
                </div>

                <FilterPresentationVenue filterValue={filterValue} setFilterValue={setFilterValue} setCurrentPage={setCurrentPage} />

                <div className='public-main-style2'>
                    <table className='public-main-style2-item'>
                        <thead>
                            <tr className='public-main-style2-thead'>
                                <th style={{ textAlign: 'left', paddingLeft: '20px' }}>场地名称</th>
                                <th>所属校区</th>
                                <th style={{ width: '50px' }}></th>
                            </tr>
                        </thead>

                        <tbody>
                            {venueData.list && (venueData.list.length > 0 ? (venueData.list.map((item) => (
                                <tr className='public-main-style2-tbody' key={item.id} onClick={() => { editVenue(item.id, item.name, item.campus, item.slot_type) }}>
                                    <td style={{ textAlign: 'left', paddingLeft: '20px' }}>{item.name}</td>
                                    <td>{CAMPUS_MAP[item.campus]}</td>
                                    <td style={{ width: '100px' }}>
                                        <div className='public-main-style2-operation-box'>
                                            <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                                                <div className='public-main-style2-operation' onClick={(event) => { event.stopPropagation(); deleteVenue(item.id, item.name) }}>
                                                    <MyIcon name='huishouzhan' />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </td>
                                </tr>
                            ))) : (
                                <tr className='public-main-style2-tbodyEmpty'>
                                    <td colSpan="3"><span>暂无数据</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className='pagination'>
                    <Pagination
                        current={currentPage}
                        total={venueData.total}
                        pageSize={20}
                        onChange={(page) => setCurrentPage(page)}
                        showTotal={(total) => `共${total}条`}
                        showSizeChanger={false}
                        hideOnSinglePage={true}
                        showQuickJumper={true}
                    />
                </div>
            </div>

            {isDeleteVisible && <DeletePresentationVenue
                data={propsData}
                getVenueData={getVenueData}
                isOpen={isDeleteVisible}
                isCancel={() => { setIsDeleteVisible(false) }}
            />}
            {isAddVisible && <AddPresentationVenue
                getVenueData={getVenueData}
                isOpen={isAddVisible}
                isCancel={() => { setIsAddVisible(false) }}
            />}
            {isEditVisible && <EditPresentationVenue
                data={propsData}
                getVenueData={getVenueData}
                isOpen={isEditVisible}
                isCancel={() => { setIsEditVisible(false) }}
            />}
            {isEmptyVisible && <EmptyPresentationVenue
                filterValue={filterValue}
                getVenueData={getVenueData}
                isOpen={isEmptyVisible}
                isCancel={() => { setIsEmptyVisible(false) }}
            />}
        </div>
    )
}
